import { ACTION_PERMISSION_MAP } from './constants';

export const checkPermissions = (
  actionType,
  permissions
) => {
  if (!permissions) return false;

  const permissionKey = ACTION_PERMISSION_MAP[actionType];

  if (!permissionKey) return false;

  return Boolean(
    permissions[permissionKey]
  );
};

export const checkWritePermissionsDisabled = (permissions) => {
  if (!permissions) return false;
  return Object.entries(permissions)
    .filter(([key]) => key !== 'read')
    .every(([, value]) => value === false);
};
